<div class="p-0 p-md-8">
  <div *ngIf="loading" class="loading-msg">{{ 'Loading positions...' | translate }}</div>
  <div *ngIf="error" class="error-msg">{{ error | translate }}</div>

  <app-custom-table *ngIf="!loading && !error" [jobs]="jobs" [columns]="columns" [filters]="filters"
    [searchKey]="searchKey" [title]="'Job Position' | translate" [showPostButton]="true" [postButtonLabel]="'Add New Position' | translate"
    [serverSidePagination]="true" [totalElements]="totalElements" [serverPage]="serverPage"
    (pageChanged)="onPageChanged($event)" (postClicked)="onPostVacancy()" (editClicked)="onEdit($event)"
    (deleteClicked)="onDelete($event)"
      (filterChanged)="onFilterChanged($event.key, $event.value)"
        (searchChanged)="onSearchChange($event)"  [externalSearchQuery]="searchQuery">
  </app-custom-table>
</div>